"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/dom-helpers/util/inDOM.js
 ** module id = ./node_modules/react-bootstrap/node_modules/dom-helpers/util/inDOM.js
 ** module chunks = 0
 **/